import { render } from "./ProjectTemplateBox.vue?vue&type=template&id=174047c5&lang=pug"
import script from "./ProjectTemplateBox.vue?vue&type=script&lang=js"
export * from "./ProjectTemplateBox.vue?vue&type=script&lang=js"

import "./ProjectTemplateBox.vue?vue&type=style&index=0&id=174047c5&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__